// Optional: hide the native splash screen once React mounts.
// Import this in src/index.js AFTER ReactDOM.render for a smooth handoff.
// Safe to call on web — no-ops when not running inside Capacitor.
import { Capacitor } from "@capacitor/core";

export async function bootMobile() {
  if (!Capacitor.isNativePlatform()) return;

  try {
    const { SplashScreen } = await import("@capacitor/splash-screen");
    const { StatusBar, Style } = await import("@capacitor/status-bar");
    const { App } = await import("@capacitor/app");

    // Hide splash after the shell finishes hydrating
    setTimeout(() => { SplashScreen.hide().catch(() => {}); }, 400);

    // Dark status bar to match the navy hero
    StatusBar.setStyle({ style: Style.Dark }).catch(() => {});
    StatusBar.setBackgroundColor({ color: "#0a1830" }).catch(() => {});

    // Deep-link handler: navigate on back button (Android) instead of exit
    App.addListener("backButton", ({ canGoBack }) => {
      if (canGoBack) window.history.back();
      else App.exitApp();
    });
  } catch (e) {
    console.warn("[mobile] boot skipped:", e);
  }
}
